export const cabinetUrl = 'https://user.myproxy7.com/'

// ?trial=1 — только с кнопки «Попробовать за 10 ₽»: кабинет сразу создаёт ключ
function withTrialQuery(url) {
  try {
    const parsed = new URL(url)
    parsed.searchParams.set('trial', '1')
    return parsed.toString()
  } catch {
    return url.includes('?') ? `${url}&trial=1` : `${url}?trial=1`
  }
}

export const trialStartUrl = withTrialQuery(cabinetUrl)
